import { createColumnHelper } from "@tanstack/react-table";

import formatDate from "@/utils/format-date";
import TransactionAmount from "../../transaction-amount";

const columnHelper = createColumnHelper();

const LOCATION_TABLE_COLUMNS = [
  {
    accessorKey: "merchant",
    header: "Merchant",
  },
  columnHelper.accessor((data) => ({ amount: data.amount, kind: data.kind }), {
    id: "amount",
    header: () => "Amount",
    enableSorting: true,
    cell: (info) => (
      <TransactionAmount
        amount={info.getValue().amount}
        kind={info.getValue().kind}
      />
    ),
  }),
  {
    accessorKey: "date",
    header: "Date",
    enableSorting: true,
    cell: ({ getValue }) => formatDate(getValue()),
  },
  {
    accessorKey: "location.address",
    header: "Address",
  },
  {
    accessorKey: "location.city",
    header: "City",
  },
  {
    accessorKey: "location.region",
    header: "State",
  },
  {
    accessorKey: "location.postalCode",
    header: "Zip Code",
  },
  columnHelper.accessor(({ description }) => description, {
    id: "description",
    header: () => "Description",
    cell: (info) => <p className="max-w-md">{info.getValue()}</p>,
  }),
];

export default LOCATION_TABLE_COLUMNS;
